import { getJson, sendJson } from './http'

export async function getModalDraft<T extends Record<string, unknown>>(path: string): Promise<T | null> {
  const result = await getJson<{ werte: T | null }>(path)
  return result.werte
}

export function saveModalDraft(path: string, werte: Record<string, unknown>): Promise<void> {
  return sendJson<void>(path, 'PUT', { werte })
}
